import { IInputOnBlurEvent, IInputOnChangeEvent } from "@components/inputs/input";
import { NumericInput } from "@components/inputs/numericInput/NumericInput";
import { IPrPayslipEntity } from "@odata/GeneratedEntityTypes";
import { IFormTableListRow } from "@pages/payroll/payslip/formTableList/FormTableList";
import { Cell } from "@pages/payroll/payslip/formTableList/FormTableList.styles";
import i18next from "i18next";
import React, { useCallback, useState } from "react";

import { BasicInputSizes, TextAlign, ValidationErrorType } from "../../../../enums";
import { IValidationError, ValidationMessage } from "../../../../model/Validator.types";
import { FormStorage } from "../../../../views/formView/FormStorage";
import { printItemValue } from "@pages/payroll/payslip/formTableList/FormTableList.utils";

interface IProps {
    row: IFormTableListRow;
    storage: FormStorage<IPrPayslipEntity>;
}

// Component renders one FormTableListEditDialogRow, which displays original value and input field for editing.
const FormTableListEditDialogRow: React.FC<IProps> = ({ row, storage }) => {
    const [value, setValue] = useState<number>(row.value as number);
    const [error, setError] = useState<IValidationError>(null);

    const { path, Id, propName, origValue, unit } = row.editableInfo;

    let itemsBc = storage.data.bindingContext;
    if (path) {
        itemsBc = itemsBc.navigate(path);
    }
    itemsBc = itemsBc.navigate("Items"); // PrPayslipEntity.Items or PrPayslipEmploymentEntity.Items
    const bc = itemsBc.addKey(Id).navigate(propName);

    const handleChange = useCallback((args: IInputOnChangeEvent<number>) => {
        setValue(args.value);
        storage.setTemporalData(bc, { value: args.value });
    }, [bc, storage]);

    const handleBlur = useCallback((args: IInputOnBlurEvent) => {
        const errorType = isNaN(value) ? ValidationMessage.NotANumber : null;
        const error = errorType ? { errorType: ValidationErrorType.Field, message: i18next.t(`Common:${errorType}`) } : null;
        setError(error);
        storage.setTemporalError(bc, error);
        storage.addActiveField(itemsBc);
        // refresh whole dialog to update error state (disable / enable save button)
        storage.addActiveField(storage.data.bindingContext);
        storage.refreshFields(true);
    }, [bc, itemsBc, storage, value]);

    return (<>
                <Cell isSubRow={row.isSubRow}>{row.title}</Cell>
                <Cell isSubRow={row.isSubRow}>{printItemValue(row, origValue)}</Cell>
                <NumericInput value={value}
                              error={error}
                              width={BasicInputSizes.S}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              textAlign={TextAlign.Right}
                              unit={unit}/>
            </>
    );
};

export default FormTableListEditDialogRow;